import { useUpdateClinic } from '@/services/mutations/clinic';
import { ClinicForm } from './components/ClinicForm';
import { useNavigate, useParams } from 'react-router-dom';
import { PageTitle } from '@/components/ui/PageTitle';
import { useGetClinic } from '@/services/queries/clinic';

const EditClinic = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const { mutate, isPending } = useUpdateClinic(() => {
		navigate('/admin/clinicas');
	});

	const onSubmit = (body: Partial<Clinics.Create>) => mutate(body);

	const { data } = useGetClinic(id as string);

	const onBack = () => navigate('/admin/clinicas');

	return (
		<section className="space-y-4 px-4 py-8">
			<PageTitle
				text="Clínicas"
				// type="clinic"
			/>
			{data && (
				<ClinicForm
					formTitle="Editar clínica"
					onSubmit={onSubmit}
					isSubmitting={isPending}
					onBack={onBack}
					defaultValues={data}
				/>
			)}
		</section>
	);
};

export { EditClinic };
